<template>
  <div id="home" class="main page--home">
    <Sea ref="sea" />
    <Deep ref="deep" />
    <Island ref="island" />
    <div style="background-color: #a0c5e1; padding-bottom: 120px;">
      <What ref="what" />
      <Title :item="$t('homeTitle1')" :dark="false" />
      <Slide />
    </div>
    <div style="background-color: #fff;">
      <Title :item="$t('homeTitle2')" :dark="true" />
      <Swipe ref="swipe" :items="items" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sea from '@/components/Sea.vue'
import Deep from '@/components/Deep.vue'
import Island from '@/components/Island.vue'
import What from '@/components/What.vue'
import Title from '@/components/Title.vue'
import Slide from '@/components/Slide.vue'
import Swipe from '@/components/Swipe.vue'
import { getCommendNewsUrl } from '@/util/url.js'
import axios from 'axios'

export default {
  name: 'home',
  components: {
    Sea,
    Deep,
    Island,
    What,
    Title,
    Slide,
    Swipe
  },

  data () {
    return {
      items: [
        {
          ID: -1,
          NEWTYPE: -1,
          BIGPIC: '',
          SHOWTIME: '',
          TITLE: '',
          JJ: ''
          // note1: '0 大洋世家-海洋事业部'
        },
        {
          ID: -2,
          NEWTYPE: -2,
          BIGPIC: '',
          SHOWTIME: '',
          TITLE: '',
          JJ: ''
          // note1: '1 大洋世家-海洋事业部'
        },
        {
          ID: -3,
          NEWTYPE: -3,
          BIGPIC: '',
          SHOWTIME: '',
          TITLE: '',
          JJ: ''
          // note1: '2 大洋世家-海洋事业部'
        }
      ]
    }
  },

  mounted () {
    document.title = this.$t('title')
    this.$nextTick(() => {
      if (window.scrollBar) window.scrollBar.scrollTop = 0
      const time = 1500

      setTimeout(() => {
        this.$refs.sea.start()
        this.$refs.deep.start()
        this.$refs.island.start()
        this.$refs.what.start()
        // this.loader.hide()
      }, time)
    })

    this.fechData()
  },

  methods: {
    fechData () {
      const url = getCommendNewsUrl(this.$store.state.lang)
      axios.get(url).then(res => {
        // console.log(res)
        if (res && res.data && res.data.length > 0) {
          this.items = res.data
          this.$nextTick(() => {
            this.$refs.swipe.update()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  background: #05111f;
}
</style>
